import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {AppComponent} from '../../app.component';
import { format } from 'url';
import { AlertService } from 'src/app/alertpopup/_alert/alert.service';
//import { AlertService } from '../../alertpopup/_alert';

@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.component.html',
    styleUrls: ['./set-password.component.css'],
    standalone: false
})
export class SetPasswordComponent implements OnInit {
  url: string;
  pageUrl:string;
  userID:string;
  Role:string;
  IsAdmin:boolean;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient,private alertService: AlertService) {
    this.url = AppComponent.baseURL;
   }

  ngOnInit() {
    this.pageUrl = this.router.url;
    let pagehead = this.pageUrl.split('/');
    this.userID = pagehead[2];
    this.Role = localStorage.getItem("Role");
    this.IsAdmin = this.Role == "0";
  }
  
  goToPage(): void {
    this.router.navigate(['/login']);
  }

  onClickSubmit(formData){
    if(formData.confirmPassword =="" || formData.newpassword =="")
    {
      this.alertService.showError('Both fields New Password and Confirm New Password are required.');
      return;
    }
    if(formData.confirmPassword != formData.newpassword)
    {
      this.alertService.showError('New Password and Confirm New Password do not match.');
      return;
    }
    this.http.get(
        this.url + 'User/SetPassword?UserID='+ this.userID +'&OldPassword=' + formData.currentPassword + '&NewPassword=' + formData.newpassword)
        .subscribe( (data: Result) =>   {
          this.alertService.showSuccess(data.Message);
          // this.alertService.success(data.Message,this.options);
         },
        (error) => {
          // this.alertService.error('Internal Server Error',true);
        }
      );
  }
}

export interface Result {
  Status: number;
  Message: string;  
}
